/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Exercise_Too_DifficultInputs */

const en_us2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That exercise is above your plan's level for now.`)
};

const pt_br2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse exercício passa do nível do seu plano por enquanto.`)
};

const es_419_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese ejercicio está por encima del nivel de tu plan por ahora.`)
};

const pt_pt2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse exercício está acima do nível do teu plano, por agora.`)
};

const fr_fr2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet exercice dépasse le niveau de ton programme pour l'instant.`)
};

const de_de2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung liegt vorerst über dem Niveau deines Plans.`)
};

const it_it2_plan_exercise_too_difficult = /** @type {(inputs: Plan_Exercise_Too_DifficultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'esercizio per ora è sopra il livello della tua scheda.`)
};

/**
* | output |
* | --- |
* | "That exercise is above your plan's level for now." |
*
* @param {Plan_Exercise_Too_DifficultInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_exercise_too_difficult = /** @type {((inputs?: Plan_Exercise_Too_DifficultInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Exercise_Too_DifficultInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_exercise_too_difficult(inputs)
	if (locale === "es-419") return es_419_plan_exercise_too_difficult(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_exercise_too_difficult(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_exercise_too_difficult(inputs)
	if (locale === "de-DE") return de_de2_plan_exercise_too_difficult(inputs)
	if (locale === "it-IT") return it_it2_plan_exercise_too_difficult(inputs)
	return en_us2_plan_exercise_too_difficult(inputs)
});
export { plan_exercise_too_difficult as "plan.exercise_too_difficult" }